import Appsignal from "@appsignal/javascript";
import { plugin as console_plugin } from "@appsignal/plugin-breadcrumbs-console";
import { plugin as network_plugin } from "@appsignal/plugin-breadcrumbs-network";
import { plugin as window_error_plugin } from `@appsignal/plugin-window-events`
import { plugin as path_decorator_plugin } from `@appsignal/plugin-path-decorator`

const appsignal = new Appsignal({
    key: process.env.APPSIGNAL_FRONTEND_KEY,
    revision: process.env.APP_REVISION,
});

appsignal.use(console_plugin());
appsignal.use(network_plugin());
appsignal.use(window_error_plugin());
appsignal.use(path_decorator_plugin());

module.exports = { appsignal };
